<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        block
        v-on="on"
      >
        Create Payroll Bank
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="success"
      title="Payroll Bank"
      text="Create Payroll Bank"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="shiftCode"
                v-validate="'required'"
                :error-messages="errors.collect('shiftCode')"
                data-vv-name="shiftCode"                
                data-vv-as="shift code"                
                label="Shift Code"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="bankCode"
                label="Bank Code"
              />
            </v-col>
            <v-col cols="12">
              <span> Is Template Ready? </span>
              <v-radio-group
                v-model="isTemplateReady"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    data () {
      return {
        dialog: false,        
        progressing: false,       
        name: null,
        shiftCode: null,
        bankCode: null,
        isTemplateReady: 0,
      }
    },
    watch: {
      dialog (value) {
        if (!value) return       
        this.$validator.reset() 
        this.name = null
        this.shiftCode = null
        this.bankCode = null
        this.isTemplateReady = 0
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true

            this.$api.payrollBanks().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {      
                  this.$emit('created', res.data)                
                  this.progressing = false
                  this.dialog = false
                }
              })
          })
      },   
   
      prepareFormData () {
        return {
          name: this.name,
          shift_code: this.shiftCode,
          bank_code: this.bankCode,
          is_template_ready: this.isTemplateReady,
        }
      },
    },
  }
</script>
